import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { ECardType } from './typing';
@Component({
  selector: 'm-functional-card',
  template: `
    <div class="m-functional-card-container">
      <div class="m-functional-card-bg" [style.backgroundImage]="'url(' + mBgUrl + ')'">
        <div class="m-functional-card-bg-block">
          <ng-container *ngIf="isTemplateRef; else elseTemplate">
            <ng-container *nzStringTemplateOutlet="mIcon">{{ mIcon }}</ng-container>
          </ng-container>
          <ng-template #elseTemplate>
            <m-functional-card-icon [mType]="type"></m-functional-card-icon>
          </ng-template>
          <p class="m-functional-card-bg-title">{{ mBgTitle }}</p>
          <p class="m-functional-card-bg-intro">{{ mBgIntro }}</p>
        </div>
        <div class="m-functional-card-bg-operations">
          <ng-content></ng-content>
        </div>
      </div>
      <div class="m-functional-card-detail">
        <p class="m-functional-card-detail-name">{{ mName }}</p>
        <p class="m-functional-card-detail-desc">{{ mDescription }}</p>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  preserveWhitespaces: true
})
export class MFunctionalCardComponent {
  @Input() mBgUrl!: string;
  @Input() mName!: string;
  @Input() mDescription!: string;
  @Input() mBgTitle!: string;
  @Input() mBgIntro!: string;
  @Input() mIcon!: ECardType | TemplateRef<void>;

  get isTemplateRef(): boolean {
    return this.mIcon instanceof TemplateRef;
  }

  get type(): ECardType {
    return this.mIcon as ECardType;
  }
}
